import React from 'react';
import PropTypes from 'prop-types';

import Readability from '../../Review/components/Readability';

import './Footer.css';

const Footer = ({
  comment,
  editable,
  review: { readability },
  onReadabilityChange,
  onReviewSubmit,
  onCommentChange,
  highlightRequired,
}) => (
  <div
    className={`navbar navbar-inverse flex-row bottom flex-bottom-row ${comment || editable ? '' : 'hidden'}`}
    style={{ maxHeight: '40%' }}
  >
    {editable
      && (
        <>
          <div className="work-area footer-left">
            <div className="footer-left-items">
              <div className="footer-text-container">
                <h4 className="m-0 valign-middle">ADD YOUR REVIEW</h4>
                <br />
                <h5 className="m-0 valign-middle font-weight-normal">
                  How would you rate the translation?
                  <br />
                  How natural does it sound?
                </h5>
              </div>
              <div className="footer-dropdown-container">
                <Readability
                  value={readability}
                  onChange={onReadabilityChange}
                  highlightRequired={highlightRequired}
                />
              </div>
            </div>
          </div>
          <div className="work-area footer-right">
            <div className="footer-right-items">
              <div className="footer-right-textarea-container">
                <textarea
                  id="feedback_comment_textarea"
                  rows="3"
                  cols="42"
                  name="fb"
                  onChange={({ target: { value } }) => onCommentChange(value)}
                  value={comment}
                  dir="auto"
                  placeholder="Any additional feedback to the translator"
                  className="feedback-textarea"
                />
              </div>
              <div className="footer-right-button">
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={onReviewSubmit}
                >
                  Submit
                </button>
              </div>
            </div>
          </div>
        </>
      )}
    {!editable
        && (
        <div className="container-fluid">
          <div className="work-area-full">
            <p>Feedback to the translator:</p>
            <p id="feedback_comment" dir="auto">{comment}</p>
          </div>
        </div>
        )}
  </div>
);

Footer.propTypes = {
  comment: PropTypes.string,
  editable: PropTypes.bool,
  review: PropTypes.object.isRequired,
  onReviewSubmit: PropTypes.func.isRequired,
  onCommentChange: PropTypes.func.isRequired,
  onReadabilityChange: PropTypes.func.isRequired,
  highlightRequired: PropTypes.bool,
};

Footer.defaultProps = {
  editable: false,
  comment: '',
  highlightRequired: false,
};

export default Footer;
